<div class="language-dropdown-container">

    <!-- Trigger Button -->
    <button [matMenuTriggerFor]="languageMenu" class="lang-trigger-btn d-flex align-items-center gap-1 px-0">
        <mat-icon class="globe-icon">language</mat-icon>
        <span class="current-code">{{ currentLangCode() | uppercase }}</span>
        <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
    </button>

    <!-- Dropdown Menu -->
    <mat-menu #languageMenu="matMenu" class="custom-lang-menu">
        @for (lang of languages; track lang.code) {
        <button mat-menu-item (click)="selectLanguage(lang.code)" [class.active-lang]="currentLangCode() === lang.code">
            <span class="menu-label">{{ lang.label }}</span>
        </button>
        }
    </mat-menu>

</div>